module.exports = __webpack_public_path__ + "img/space-24.be20b0c9.svg";